import { render, staticRenderFns } from "./ClicksUnicos.vue?vue&type=template&id=f26f7c56"
import script from "./ClicksUnicos.vue?vue&type=script&lang=js"
export * from "./ClicksUnicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports